import React, { Component } from 'react';
import '../components-style.css';

class TimerDisplay extends Component {

    //Display render
   	render(){
        return (
            <div style={{flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
                {(this.props.timerDisplayString !== "-") ?
                    <div id="row-timer-style">
                        {this.props.timerDisplayString}
                    </div>
                    :
                    null
                }
            </div>
        )
   	}
}
export default(TimerDisplay);